import React, {Component} from 'react';
import {Button} from 'semantic-ui-react';

import ClientDialog from "../../components/contacts/ClientDialog";
import QuestionDialog from "../extras/QuestionDialog";
import SaleData from "../../data/SaleData";
import ClientData from "../../data/ClientData";
import connect from "react-redux/es/connect/connect";
import {showFindClientModal} from "../../actions/FindClientAction";
import {selectClient} from "../../actions/ClientSelectActions";
import {showToast} from "../../actions/ToastAction";
import {clientDialog} from "../../actions/ClientDialogAction";

class ClientOrder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            client: props.client,
            index: props.index,
            sale: props.sale,
            saving: this.props.saving,
            deleting: false,
            load_client: false
        };
        this.updateClient = this.updateClient.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.select_client && nextProps.select_client.hasOwnProperty('id')){
            this.updateClient(nextProps.select_client);
            this.props.selectClient(null);
        }
    }

    editDialog = () => {
        this.setState({load_client:true});
        ClientData.get(this.state.client.id,(client)=>{
            this.setState({client});
            this.props.clientDialog({open:true, client});
        }).finally(() => this.setState({load_client:false}) );
    };

    updateClientData = (client) => {
        this.setState({client});
        this.props.selectClient(null);
    };

    updateData(client, saving){
        this.setState({client, saving});
    }

    deleteConfirm(){
        this.setState({deleting:true});
        this.updateClient(null);
        this.props.selectClient(null);
    };

    updateClient(client){
        this.setState({saving:true});
        let data={
            id:this.state.sale,
            client: client ? client.id:null
        };
        SaleData.client(data,(res)=>{
            if(res && res.update){
                this.setState({client: res.client});
            }else{
                this.props.showToast({
                    message: 'Tenemos un problema, inténtalo nuevamente!',
                    type: 'error'
                });
            }
            this.setState({saving:false, deleting:false});
        });
    };

    render() {
        return (
            <div>
                {this.state.client ? <span>
                    <p><strong>Cliente: </strong>{this.state.client.full_name}</p>
                </span>:null}
                {this.state.client ? <Button.Group size='tiny' basic fluid>
                    <Button
                        labelPosition='left'
                        icon='edit'
                        content='Editar'
                        loading={this.state.load_client}
                        disabled={this.state.load_client}
                        onClick={this.editDialog}
                    />
                    {this.props.can_delete ? <Button
                        labelPosition='right'
                        icon='trash'
                        content='Borrar'
                        loading={this.state.deleting}
                        disabled={this.state.deleting}
                        onClick={ () => this.refs.question_dialog.open('Quitar este cliente', this.state.client.id)}
                    />:null}
                </Button.Group>:
                    <Button
                        primary
                        icon='user'
                        fluid
                        labelPosition='left'
                        content='Agregar Cliente'
                        loading={this.state.saving}
                        disabled={this.state.saving}
                        onClick={
                            () => this.props.showFindClientModal({open: true})
                        }
                    />
                }
                <ClientDialog
                    ref="client_dialog"
                    callbackUpdateData={this.updateClientData}
                />
                <QuestionDialog ref='question_dialog' message='Quitar este cliente' callbackConfirm={this.deleteConfirm} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        select_client: state.get('select_client'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showFindClientModal(data) {
            dispatch(showFindClientModal(data));
        },
        selectClient(client){
            dispatch(selectClient(client))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        clientDialog(client){
            dispatch(clientDialog(client))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClientOrder);



// WEBPACK FOOTER //
// ./src/components/sale/ClientOrder.js